import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'

import { createVuetify, type ThemeDefinition } from 'vuetify'
import { en, ru } from 'vuetify/locale'
import { defaultColors, defaultColorsLight } from '@/types/theme'

// Тема Glassmorphism Dark
const glassDark: ThemeDefinition = {
  dark: true,
  colors: {
    background: defaultColors.background,
    surface: defaultColors.surface,
    'surface-variant': '#334155',
    'on-surface-variant': '#94a3b8',
    primary: defaultColors.primary,
    'primary-darken-1': '#166534',
    secondary: defaultColors.secondary,
    'secondary-darken-1': '#14532d',
    accent: defaultColors.accent,
    error: defaultColors.error,
    info: defaultColors.info,
    success: defaultColors.success,
    warning: defaultColors.warning,
    'on-background': '#f8fafc',
    'on-surface': '#f1f5f9',
    'on-primary': '#ffffff',
    'on-secondary': '#ffffff',
    'on-error': '#ffffff',
    'on-info': '#ffffff',
    'on-success': '#ffffff',
    'on-warning': '#000000',
  },
  variables: {
    'border-color': '#334155',
    'border-opacity': 0.12,
    'high-emphasis-opacity': 0.87,
    'medium-emphasis-opacity': 0.6,
    'disabled-opacity': 0.38,
    'idle-opacity': 0.04,
    'hover-opacity': 0.08,
    'focus-opacity': 0.12,
    'selected-opacity': 0.08,
    'activated-opacity': 0.12,
    'pressed-opacity': 0.12,
    'dragged-opacity': 0.08,
    'theme-kbd': '#1e293b',
    'theme-on-kbd': '#f1f5f9',
    'theme-code': '#1e293b',
    'theme-on-code': '#f1f5f9',
  },
}

// Тема Glassmorphism Light
const glassLight: ThemeDefinition = {
  dark: false,
  colors: {
    background: defaultColorsLight.background,
    surface: defaultColorsLight.surface,
    'surface-variant': '#e2e8f0',
    'on-surface-variant': '#475569',
    primary: defaultColorsLight.primary,
    'primary-darken-1': '#166534',
    secondary: defaultColorsLight.secondary,
    'secondary-darken-1': '#14532d',
    accent: defaultColorsLight.accent,
    error: defaultColorsLight.error,
    info: defaultColorsLight.info,
    success: defaultColorsLight.success,
    warning: defaultColorsLight.warning,
    'on-background': '#0f172a',
    'on-surface': '#1e293b',
    'on-primary': '#ffffff',
    'on-secondary': '#ffffff',
    'on-error': '#ffffff',
    'on-info': '#ffffff',
    'on-success': '#ffffff',
    'on-warning': '#000000',
  },
  variables: {
    'border-color': '#cbd5e1',
    'border-opacity': 0.12,
    'high-emphasis-opacity': 0.87,
    'medium-emphasis-opacity': 0.6,
    'disabled-opacity': 0.38,
    'idle-opacity': 0.04,
    'hover-opacity': 0.08,
    'focus-opacity': 0.12,
    'selected-opacity': 0.08,
    'activated-opacity': 0.12,
    'pressed-opacity': 0.12,
    'dragged-opacity': 0.08,
    'theme-kbd': '#e2e8f0',
    'theme-on-kbd': '#1e293b',
    'theme-code': '#e2e8f0',
    'theme-on-code': '#1e293b',
  },
}

export default createVuetify({
  theme: {
    defaultTheme: 'glassDark',
    themes: {
      glassDark,
      glassLight,
    },
  },
  locale: {
    locale: 'ru',
    fallback: 'en',
    messages: { ru, en },
  },
  defaults: {
    VBtn: {
      variant: 'flat',
      rounded: 'lg',
    },
    VCard: {
      rounded: 'lg',
      elevation: 0,
    },
    VTextField: {
      variant: 'outlined',
      density: 'comfortable',
      rounded: 'lg',
    },
    VSelect: {
      variant: 'outlined',
      density: 'comfortable',
      rounded: 'lg',
    },
    VChip: {
      rounded: 'lg',
    },
    VAlert: {
      rounded: 'lg',
      variant: 'tonal',
    },
  },
})
